module.exports = __webpack_public_path__ + "img/clue1.ea9f5042.png";